import React, { useEffect, useState, useRef, useCallback } from 'react';
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';
import { Dropdown, Table, Pagination, Spinner, Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faFilter, faPowerOff, faTrash } from "@fortawesome/free-solid-svg-icons";
import { getGroupUsers } from '../services/api';
import axios from "axios";

function GroupUser() {
  const [showFilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState("");
  const [quantity, setQuantity] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredCodes, setFilteredCodes] = useState([]);

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isMounted = useRef(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", password: "", confirm_password: "" });
  const [apiResponse, setApiResponse] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    document.body.classList.add('loged-body');

    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      fetchData();
      isMounted.current = true;
    }
  }, [currentUserId]);

  const fetchData = async () => {
    try {
      const data = await getGroupUsers();
      console.log('data',data);
      const response = data.groupUsers;
      if(response[0]){
        setCurrentUserId(response[0].user_id);
      }
      setRecords(response);
      setFilteredCodes(response);
    } catch (err) {
      
      const response = [
        {
          id: 1,
          type: "Contact Page",
          image: "https://urqr.urqr.pro/qrcodes/GN9Bwj9MzmAe.png",
          title: "QR Code 1",
          modified: "2024-11-25",
          scans: 15,
          status: 1,
        },
      ];
      setRecords(response);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = useCallback(() => {
    let updatedCodes = [...records]; // Create a copy of records to apply filters
    if (search) {
      updatedCodes = updatedCodes.filter((qr) =>
        qr.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    setFilteredCodes(updatedCodes);
    setCurrentPage(1); // Reset to first page when filters change
  }, [search, records]);

  useEffect(() => {
    handleFilter();
  }, [handleFilter]); // Depend on handleFilter to avoid the warning

  const totalRecords = filteredCodes.length;
  const totalPages = Math.ceil(totalRecords / quantity);
  const paginatedCodes = filteredCodes.slice(
    (currentPage - 1) * quantity,
    currentPage * quantity
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleStatusChange = async (id, currentStatus) => {
    try {
      setLoading(true);
      const response = await axios.post('https://urqr.urqr.pro/api/users/update-groupUser-status', {
        id,
        status: currentStatus === 1 ? 0 : 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },});
      fetchData();
      alert(response.data.message);
    } catch (error) {
      setLoading(false);
      alert('Failed to update status. Please try again.');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this item?')) {
      try {
        setLoading(true);
        const response = await axios.delete(
          `https://urqr.urqr.pro/api/users/delete-groupUser-record/${id}`, 
          {
              headers: {
                  Authorization: `Bearer ${token}`,
              },
          }
        );
        fetchData();
        alert(response.data.message);
      } catch (error) {
        setLoading(false);
        alert('Failed to delete the record. Please try again.');
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setApiResponse(null);
    try {
      const response = await axios.post("https://urqr.urqr.pro/api/users/group-register", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setApiResponse({ message: response.data.msg, type: "success" });
      setTimeout(() => {      
        setShowModal(false);
      }, 3000);
      setFormData({
        name: "",
        email: "",
        password: "",
        confirm_password: "",
      });
      fetchData(); // Refresh records
    } catch (error) {
      const errorData = error.response?.data;
      if (errorData && errorData.error) {
        const errorMessages = Object.values(errorData.error)
          .flat()
          .join(" ");
        setApiResponse({ message: errorMessages, type: "error" });
      } else {
        setApiResponse({ message: "An unexpected error occurred", type: "error" });
      }

    }
  };

  return (
    <>
      <WebNav />
      <Sidebar />
      <div className="mt-4 user-panel-body">
        {/* Heading with Filter Button */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h3>Group Users</h3>
          <Button variant="primary" onClick={() => setShowModal(true)}>
            Add New User
          </Button>
        </div>
        <div className='d-flex justify-content-end'>
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() => setShowFilter(!showFilter)}
          >
            <FontAwesomeIcon icon={faFilter} className="me-1" />
            Filter
          </button>
        </div>

        {/* Modal Form for Adding New User */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add New User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {apiResponse && (
              <div className={`alert ${apiResponse.type === "success" ? "alert-success" : "alert-danger"}`}>
                {apiResponse.message}
              </div>
            )}
            <Form onSubmit={handleFormSubmit}>
              <Form.Group className="mb-3" controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter name"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter email"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter password"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formConfirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleInputChange}
                  placeholder="Confirm password"
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Filter Section */}
        <div className={`filter-section ${showFilter ? "show" : ""}`}>
          <div className="d-flex flex-wrap gap-3">
            <div className="flex-grow-1">
              <label className="form-label">Search by Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            
            <div className="flex-grow-1">
              <label className="form-label">Quantity</label>
              <select
                className="form-select"
                value={quantity}
                onChange={(e) => setQuantity(parseInt(e.target.value))}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <Table bordered hover responsive className="mt-3 p-3 border rounded my-qr-table">
          <thead style={{ background: "linear-gradient(to right, #6a11cb, #2575fc)", color: "#fff" }}>
            <tr className="text-center">
              <th>Name</th>
              <th>E-mail</th>
              <th>Status</th>
              {/* <th>Modified</th> */}
              <th>More</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <div>
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-2">Loading...</p>
                  </div>
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <p className="text-danger">An error occurred while fetching the data.</p>
                </td>
              </tr>
            ) : paginatedCodes.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center">
                  <p className="text-muted">No Records Found</p>
                </td>
              </tr>
            ) : (
              paginatedCodes.map((qr) => (
                <tr key={qr.id} className="align-middle text-center">
                  <td>{qr.name}</td>
                  <td>{qr.email}</td>
                  <td>{qr.status === 1 ? "Active" : "Deactivated"}</td>
                  {/* <td>{moment(qr.updated_at).format('MM/DD/YYYY HH:mm:ss')}</td> */}
                  <td>
                  <Dropdown>
                    <Dropdown.Toggle as="button" className="btn btn-sm btn-secondary border-0 p-0">
                      <FontAwesomeIcon icon={faEllipsisV} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => handleStatusChange(qr.id, qr.status)}>
                        <FontAwesomeIcon icon={faPowerOff} size="sm" className="me-3" />
                        {qr.status === 1 ? "Deactivate" : "Activate"}
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(qr.id)}>
                        <FontAwesomeIcon icon={faTrash} size="sm" className="me-3" />
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        {/* Pagination and Results */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span>
            Showing{" "}
            {totalRecords === 0
              ? "0"
              : `${(currentPage - 1) * quantity + 1}-${
                  Math.min(currentPage * quantity, totalRecords)
                }`}{" "}
            out of {totalRecords} results.
          </span>
          <Pagination>
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              Previous
            </Pagination.Prev>
            {Array.from({ length: totalPages }, (_, index) => (
              <Pagination.Item
                key={index}
                active={currentPage === index + 1}
                onClick={() => handlePageChange(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              Next
            </Pagination.Next>
          </Pagination>
        </div>
      </div>

    </>
  );
}

export default GroupUser;
